export const SessionEnum = {
  preApplyChannels: 'preApplyChannels',
  ApplyProduct: 'ApplyProduct',
  preApplyTaskId: 'preApplyTaskId',
  // 借款时去绑卡
  savedPayBill: 'savedPayBill',
  // 去绑卡传参 {}
  toBindCard: 'toBindCard',
  // 还款换卡绑卡回来传参
  repayBindedCard: 'bindedCard',
  //
  selectCoupon: 'selectCoupon',
  //
  afterSelectedCoupon: 'afterSelectedCoupon',
  // 银河-taskid
  yHPreApplyTaskId: 'yHPreApplyTaskId',
};
